import { render, staticRenderFns } from "./CriarUsuario.vue?vue&type=template&id=f9dbb990"
import script from "./CriarUsuario.vue?vue&type=script&lang=js"
export * from "./CriarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports